import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function CatalogPage() {
  const holidaysObserved = [
    "New Year's Day",
    "Memorial Day",
    "Independence Day",
    "Labor Day",
    "Thanksgiving (Thursday and Friday)",
    "Christmas Day",
    "Baha'i Holy Days (including Naw-Ruz, Ridvan, and other major observances)",
  ];

  const entranceRequirements = [
    "Minimum age: 14 years",
    "High School Diploma / GED: Not required",
    "Entrance test: None",
    "English proficiency: Proficient",
    "Technology requirement: Laptop required",
  ];

  const webTrack = [
    "HTML, CSS and JavaScript Fundamentals",
    "React, Node.js and Full-Stack Basics",
    "UI/UX Design and Digital Tools (Figma, Canva)",
    "3D Graphics and Animation (Blender)",
    "Career and Professional Development",
  ];

  const electronicsTrack = [
    "Electrical Theory and Circuit Fundamentals",
    "Electronic Components and Microcontrollers",
    "IoT Systems and Applications",
    "Introduction to Python and Data Handling",
    "Applied AI and Machine Learning",
    "Industry Applications and Automation",
    "Professional Skills, Productivity, and Entrepreneurship",
  ];

  const policyHighlights = [
    "Refund policy: Prorated refund by week; no refunds after Week 8; consumables/software non-refundable",
    "Attendance and make-up policy: missed sessions may be completed online, in labs, or one-on-one",
    "Non-discrimination: equitable access regardless of protected status",
    "FERPA and data privacy compliance aligned with TWC requirements",
    "Grievance and appeals: written complaints reviewed within 10 business days",
    "Enrollment limit: 25 participants per cohort",
    "Grading: Non-credit, Pass/Fail or Satisfactory/Unsatisfactory",
    "Completion requirement: 100% of assigned modules, projects, and capstone work",
  ];

  const ethicsPolicies = [
    "Youth and Vulnerable Populations Protection Policy",
    "Staff and Volunteer Conduct Policy",
    "Sustainability and Environmental Responsibility Policy",
    "Community Engagement and Social Impact Policy",
    "Technology Ethics and Development Policy",
    "Organizational Values and Code of Ethics Policy",
  ];

  return (
    <Container fluid className="project-section career-utility-page">
      <Container className="career-utility-shell">
        <p className="career-utility-eyebrow">School Catalog</p>
        <h1 className="career-utility-title">Choicest Fruit Career School Catalog</h1>
        <p className="career-utility-lead">
          <span className="catalog-lead-motto">Knowledge and Technology Serving the Welfare of Humanity</span>
          <span className="catalog-lead-detail">
            This catalog presents calendar, admissions, programs, tuition, operations, progress standards,
            and institutional policies in a single structured reference.
          </span>
        </p>

        <section className="career-utility-card">
          <h2>School Calendar and Entrance Requirements</h2>
          <p>
            <strong>Enrollment Periods:</strong> Rolling enrollment with new cohorts every 8 weeks.
          </p>
          <p>
            <strong>Program Duration:</strong> 16 weeks (approximately 320 hours per program).
          </p>
          <p>
            <strong>Typical Weekly Schedule:</strong> remote sessions Monday-Friday with morning and
            afternoon blocks, plus flexible online/independent work.
          </p>
          <p>
            <strong>Scheduled Breaks:</strong> One mid-program break of 1-2 days, coordinated by instructors.
          </p>
          <h3 className="mt-3">Holidays Observed</h3>
          <ul>
            {holidaysObserved.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <h3 className="mt-3">Entrance Requirements</h3>
          <ul>
            {entranceRequirements.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="career-utility-card">
          <h2>Programs Offered</h2>

          <h3>Program 1: Applied Electronics, IoT and AI Program</h3>
          <p>
            Non-credit occupational training, 16 weeks (~320 hours), entry-intermediate level, remote
            delivery, certificate of completion (non-licensure).
          </p>
          <p>
            <strong>Occupational Alignment:</strong> Electrical and Electronics Engineering Technicians
            (SOC 17-3023)
          </p>
          <p>
            <strong>CIP:</strong> 15.0303 - Electrical, Electronics, and Communications Engineering
            Technology/Technician
          </p>
          <h4 className="mt-2">Curriculum Highlights</h4>
          <ul>
            {electronicsTrack.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <p>
            <strong>Tools:</strong> Arduino, Raspberry Pi, sensors/modules, breadboards, Python,
            TensorFlow, Microsoft 365, GitHub, Canva, Shopify (introductory)
          </p>
          <p>
            <strong>Program Outcomes:</strong> Prepared for entry-level technician roles or internships in
            electronics, IoT support, automation, and junior AI workflow contexts.
          </p>

          <div className="career-utility-table-wrap">
            <table className="career-utility-table" aria-label="Applied Electronics IoT AI tuition and fees">
              <thead>
                <tr>
                  <th>Applied Electronics, IoT and AI Tuition and Fees</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>Base Tuition</td><td>$3,200</td></tr>
                <tr><td>Lab and Materials</td><td>$225</td></tr>
                <tr><td>Tech and Platform</td><td>$75</td></tr>
                <tr><td>Capstone and Completion Processing</td><td>$100</td></tr>
                <tr className="career-utility-table-total"><td><strong>Total Program Cost</strong></td><td><strong>$3,600</strong></td></tr>
              </tbody>
            </table>
          </div>

          <h3 className="mt-4">Program 2: Web and App Development with 3D Graphics</h3>
          <p>
            Non-credit occupational training, 16 weeks (~320 hours), entry-intermediate level,
            remote delivery, certificate of completion.
          </p>
          <p>
            <strong>Occupational Alignment:</strong> Web Developers (SOC 15-1254), Graphic Designers
            (SOC 27-1024)
          </p>
          <p>
            <strong>CIP:</strong> 11.0801 (Web Page, Digital/Multimedia and Information Resources Design),
            11.0803 (Computer Graphics)
          </p>
          <h4 className="mt-2">Curriculum Highlights</h4>
          <ul>
            {webTrack.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <p>
            <strong>Tools:</strong> VS Code, Node.js, React, Git/GitHub, Three.js, React Three Fiber,
            PostgreSQL, Figma, Canva, Blender, Adobe Creative Cloud, video editing software.
          </p>
          <p>
            <strong>Program Outcomes:</strong> Prepared for junior roles or freelance pathways in web
            development, UI/UX, digital content creation, and 3D graphics.
          </p>

          <div className="career-utility-table-wrap">
            <table className="career-utility-table" aria-label="Web app development tuition and fees">
              <thead>
                <tr>
                  <th>Web and App Development with 3D Graphics Tuition and Fees</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>Base Tuition</td><td>$2,000</td></tr>
                <tr><td>Curriculum Development and Updates</td><td>$400</td></tr>
                <tr><td>Career Services and Workshops</td><td>$200</td></tr>
                <tr><td>Career Development Tools</td><td>$200</td></tr>
                <tr><td>Software and Tools</td><td>$150</td></tr>
                <tr><td>Virtual Platform and LMS Access</td><td>$150</td></tr>
                <tr><td>Materials and Supplies</td><td>$100</td></tr>
                <tr><td>Administrative and Compliance</td><td>$150</td></tr>
                <tr><td>Work-Based Learning and Capstone Support</td><td>$200</td></tr>
                <tr><td>Virtual Support and Infrastructure</td><td>$200</td></tr>
                <tr className="career-utility-table-total"><td><strong>Total Program Cost</strong></td><td><strong>$3,750</strong></td></tr>
              </tbody>
            </table>
          </div>
          <p><strong>Optional Add-Ons:</strong> Cloud rendering, stock media, extra mentorship.</p>
        </section>

        <section className="career-utility-card">
          <h2>Policies, Operations, and Student Progress</h2>
          <ul>
            {policyHighlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <p>
            <strong>Normal Hours of Operation:</strong> Monday-Friday, 9:00 AM-8:00 PM (office availability).
            Instruction is delivered in morning and afternoon blocks.
          </p>
          <p>
            <strong>Credit:</strong> No academic credit is offered. Prior education/experience is not transferred.
          </p>
          <p>
            <strong>Placement Assistance:</strong> Resume and portfolio review, LinkedIn guidance, interview
            preparation, and partner pathway connections are provided. Placement is not guaranteed.
          </p>
        </section>

        <section className="career-utility-card">
          <h2>Facilities, Staff, and Performance Reporting</h2>
          <p>
            <strong>Facilities:</strong> Office/classroom space, computers, software licenses, and high-speed internet.
          </p>
          <p>
            <strong>School Director and Instructor:</strong> Golriz Sedaghat (13+ years electrical engineering,
            applied electronics, IoT; 10+ years coding/design; oversight of administration and instruction).
          </p>
          <p>
            <strong>Instructor:</strong> Aaron Enyetu (15+ years experience in software development,
            3D/multimedia, web applications, youth internship coordination).
          </p>
          <div className="career-utility-table-wrap">
            <table className="career-utility-table" aria-label="Performance metrics and reporting">
              <thead>
                <tr>
                  <th>Performance Metric</th>
                  <th>Target</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>Completion Rate</td><td>80-85%</td></tr>
                <tr><td>Credential Attainment</td><td>75-80%</td></tr>
                <tr><td>Employment/Entrepreneurship in Q2 post-exit</td><td>70-75%</td></tr>
                <tr><td>Median Earnings in Q2 post-exit</td><td>$14,000-$16,000</td></tr>
              </tbody>
            </table>
          </div>
          <p><strong>Reporting:</strong> Annual Student Data Reports (SDR) submitted to TWC.</p>
        </section>

        <section className="career-utility-card">
          <h2>Institutional Policies (Section 16)</h2>
          <p>
            Effective Date: 06/01/2022 | Review Cycle: Annually. The institution maintains formal policy
            frameworks covering safety, conduct, ethics, and community accountability.
          </p>
          <ul>
            {ethicsPolicies.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <p>
            These policies include mandatory training, reporting expectations, accountability actions,
            annual policy reviews, and signed acknowledgment requirements for personnel and participants.
          </p>
        </section>

        <section className="career-utility-card">
          <h2>Admissions and Enrollment Process</h2>
          <p>
            Students may enroll online by submitting an enrollment form and paying required fees.
            Orientation is included in Week 1 of each program. No entrance exam or prior coursework is required.
          </p>
          <div className="career-utility-links">
            <Link to="/admissions" className="custom-yellow-btn btn">Go to Admissions</Link>
            <Link to="/student-resources" className="btn btn-primary">View Student Resources</Link>
          </div>
        </section>

        <section className="career-utility-card">
          <h2>Downloadable Catalog PDF</h2>
          <p>
            Publish a finalized PDF version here to provide auditors, applicants, and partners with a
            signed and version-controlled copy of the full catalog.
          </p>
          <div className="career-utility-links">
            <button type="button" className="btn btn-primary" disabled>
              Download Catalog (PDF - coming soon)
            </button>
          </div>
        </section>

        <section className="career-utility-card">
          <h2>Catalog Navigation</h2>
          <ul>
            <li><Link to="/courses">Career Training Programs</Link></li>
            <li><Link to="/admissions">Admissions</Link></li>
            <li><Link to="/student-resources">Student Resources</Link></li>
          </ul>
        </section>

        <div className="career-utility-links">
          <Link to="/courses" className="custom-yellow-btn btn">Back to Career Programs</Link>
          <Link to="/admissions" className="btn btn-primary">View Admissions</Link>
          <Link to="/student-resources" className="btn btn-primary">View Student Resources</Link>
        </div>
      </Container>
    </Container>
  );
}

export default CatalogPage;
